import React, { Component } from 'react'

import Colors from '../../Colors'
import { aiItemsData } from '../../../../source/assemblyPageAiData'
import { connect } from 'react-redux'

// in toki has frontend show port and backend program port are different, so the ports are map here.
const uiPortNameMap = {
    Toki: {
        A1: 'AIN1',
        A2: 'AIN2',
        B1: 'AIN3',
        C1: 'DRV1',
        C2: 'DRV2',
        servo_motor1: 'S1',
        servo_motor2: 'S2',
        M1: 'M1',
        M2: 'M2',
    },
    Poki: {
        A1: 'AIN1',
        A2: 'AIN2',
        servo_motor1: 'S1',
        servo_motor2: 'S2',
    },
    woofKit: {
        A1: 'AIN1',
        A2: 'AIN2',
        servo_motor1: 'S1',
        servo_motor2: 'S2',
    },
}
// const tokiPortNameMap = {
//     A1: 'AIN1',
//     A2: 'AIN2',
//     B1: 'AIN3',
//     C1: 'DRV1',
//     C2: 'DRV1',
//     servo_motor1: 'S1',
//     servo_motor2: 'S2',
//     M1: 'M1',
//     M2: 'M2',
// }

class Select extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    onChange = (e) => {
        this.props.onChange(e.target.value)
    }

    //for speech mood the drop down awake ward value is 101 set here
    getOptionValue = (ele, index) => {
        // if (this.props.aiType === 'ai_mic' && index == 1) {
        //     return 101
        // } else if (this.props.aiType === 'ai_mic') {
        //     return index - 1
        // }
        return ele.id
    }

    render() {
        let connectedDevice = sessionStorage.getItem('connectedDevice')
        var style = {
            color: '#000',
            background: '#FFF',
            outline: 'none',
            texAlign: 'center',
            fontFamily: 'Halcyon_Medium ',
            height: '100%',
            width: '100%',
            border: '1px solid white',
            borderRadius: '15px',
            cursor: 'pointer',
        }

        if (this.props.disabled) style.background = Colors.disabledgrey
        // CHANGED NAMING OF FOUR IN SENSOR
        var customOptions = {}
        this.props.order.map((option, index) => {
            if (this?.props?.typeDropDown == 'trainList') {
                return
            }
            // console.log('loser', option)
            if (option == 'battery') {
                customOptions[index] = 'Select Items'
            } else if (option == '4-IN-1 SENSOR  →  RED') {
                customOptions[index] = 'PC -> COLOUR SENSOR (RED)'
            } else if (option == '4-IN-1 SENSOR  →  BLUE') {
                customOptions[index] = 'PC -> COLOUR SENSOR (BLUE)'
            } else if (option == '4-IN-1 SENSOR  →  GREEN') {
                customOptions[index] = 'PC -> COLOUR SENSOR (GREEN)'
            } else if (option == '4-IN-1 SENSOR  →  DIST') {
                customOptions[index] = 'PC Proximity Sensor'
            } else if (option == '4-IN-1 SENSOR  →  GESTURE') {
                customOptions[index] = 'PC Gesture Sensor'
            } else if (option == '4-IN-1 SENSOR  →  LIGHT') {
                customOptions[index] = 'PC Light Sensor'
            } else if (
                ['Switch_One', 'Switch_Two'].includes(option) &&
                ['Roboki'].includes(connectedDevice)
            ) {
                customOptions[index] = 'Roboki ' + option
            } else {
                if (this.props.options[option] != null) {
                    if (
                        option === 'C1' &&
                        ['Roboki'].includes(connectedDevice)
                    ) {
                        let removePortStr = this.props.options[option].replace(
                            / → .*/,
                            ''
                        )
                        customOptions[index] = removePortStr + ' \u2192 ' + 'B1'
                    } else if (
                        option === 'C2' &&
                        ['Roboki'].includes(connectedDevice)
                    ) {
                        let removePortStr = this.props.options[option].replace(
                            / → .*/,
                            ''
                        )
                        customOptions[index] = removePortStr + ' \u2192 ' + 'B2'
                    } else if (
                        ['Toki', 'Poki', 'Moki', 'woofKit'].includes(connectedDevice)
                    ) {
                        //   return `Port ${uiPortNameMap?.[connectedDevice]?.[activePort]} : ${label}`
                        let labelSplit = this.props.options[option].split('→')
                        if (
                            labelSplit[1] &&
                            uiPortNameMap?.[connectedDevice]?.[
                                labelSplit[1].trim()
                            ]
                        ) {
                            customOptions[index] =
                                labelSplit[0] +
                                ' \u2192 ' +
                                uiPortNameMap?.[connectedDevice]?.[
                                    labelSplit[1].trim()
                                ]
                        } else {
                            customOptions[index] = this.props.options[option]
                        }
                    }
                    // else if (connectedDevice == 'Toki') {
                    //     let labelSplit = this.props.options[option].split('→')
                    //     if (labelSplit[1]) {
                    //         customOptions[index] =
                    //             labelSplit[0] +
                    //             ' \u2192 ' +
                    //             tokiPortNameMap[labelSplit[1].trim()]
                    //     } else {
                    //         customOptions[index] = this.props.options[option]
                    //     }
                    // } else if (
                    //     connectedDevice == 'Moki' &&
                    //     ['G1', 'G2'].includes(option)
                    // ) {
                    //     let labelSplit = this.props.options[option].split('→')
                    //     let ee = {
                    //         G1: 'I1',
                    //         G2: 'I2',
                    //     }
                    //     if (labelSplit[1]) {
                    //         customOptions[index] =
                    //             labelSplit[0] +
                    //             ' \u2192 ' +
                    //             ee[labelSplit[1].trim()]
                    //     }
                    // }
                    else {
                        customOptions[index] = this.props.options[option]
                    }
                } else if (
                    [
                        'ai_motion',
                        'ai_color_recognition',
                        'ai_face_detection',
                        'ai_face_recognition',
                        'ai_mic',
                        'ai_lidar',
                        'ai_light',
                        'ai_proximity',
                    ].includes(option)
                ) {
                    customOptions[index] = aiItemsData[option].title2
                    // customOptions[index] = aiItemsData[option].title
                } else if (option.includes('ai_color_tracking_')) {
                    const regex = /^ai_color_tracking_(X|Y)_(blue|green|red)$/i
                    const match = option.match(regex)

                    if (match) {
                        const [, axis, color] = match

                        // Capitalize the first letter
                        const formattedColor =
                            color.charAt(0).toUpperCase() + color.slice(1)

                        customOptions[
                            index
                        ] = `Ai Color ${formattedColor} position \u2192 ${axis}`
                    }
                } else if (
                    option.includes('ai_face_tracking_X') ||
                    option.includes('ai_face_tracking_Y')
                    // option.includes('ai_color_tracking_X') ||
                    // option.includes('ai_color_tracking_Y')
                ) {
                    let faceList = this.props?.aiFaceList
                    const matches = option.match(/_(X|Y)(\d*)$/)
                    if (matches) {
                        let id = matches[2] ? matches[2] : '0'
                        if (id !== '0') {
                            const ele = faceList.find((item) => item.id === id)
                            const face = ele ? ele.label : ''
                            customOptions[
                                index
                            ] = `AI - ${face}'s Postion \u2192 ${matches[1]}`
                        } else {
                            customOptions[index] = aiItemsData[option]?.title2
                        }
                    }
                } else if (
                    (option.includes('ACCELEROMETER') ||
                        option.includes('GYRO_') ||
                        option.includes('Magnetometer') ||
                        option.includes('COLOUR_SENSOR')) &&
                    ['Poki', 'Moki', 'woofKit'].includes(connectedDevice)
                ) {
                    let mainPort = 'E'
                    if (this.connectedDevice === 'Moki') {
                        mainPort = 'D'
                    }
                    let label = option.split('_').join(' ')
                    customOptions[index] = label + ' \u2192 ' + mainPort
                } else {
                    let deviceName = ''
                    switch (connectedDevice) {
                        case 'Ace':
                            deviceName = 'PC '
                            break
                        case 'Roboki':
                            deviceName = 'Roboki '
                            break
                        default:
                            deviceName = `${connectedDevice} `
                    }

                    if (
                        [
                            'Bicounter1',
                            'Bicounter2',
                            'Biflag1',
                            'Biflag2',
                        ].includes(option)
                    ) {
                        customOptions[index] = option.replace(
                            /^Bi(.)/,
                            (m, c) => c.toUpperCase()
                        )
                    } else if (
                        [
                            'BiData1',
                            'BiData2',
                            'BT RX1',
                            'BT RX2',
                            'BT RX3',
                            'BT RX4',
                            'BT RX5',
                            'USB RX',
                            'BT Remote',
                        ].includes(option)
                    ) {
                        customOptions[index] = option
                    } else customOptions[index] = deviceName + option
                }
            }
        })
        // console.log('loser', customOptions)
        if (this.props.typeDropDown == 'read') {
            return (
                <select
                    onChange={this.onChange}
                    style={style}
                    value={this.props.selected}
                    disabled={this.props.disabled}
                >
                    {this.props.order
                        ? this.props.order.map((value, index) => {
                              //   if (
                              //       value.includes('ai_face_tracking_X') ||
                              //       value.includes('ai_face_tracking_Y') ||
                              //       value.includes('ai_color_tracking_X') ||
                              //       value.includes('ai_color_tracking_Y')
                              //   ) {
                              //       return
                              //   }
                              return (
                                  <option
                                      className="sensor-txt"
                                      key={index}
                                      value={value}
                                  >
                                      {customOptions[index]}
                                  </option>
                              )
                          })
                        : Object.keys(this.props.options).map(
                              (value, index) => (
                                  <option
                                      className="sensor-txt"
                                      key={index}
                                      value={value}
                                  >
                                      {this.props.options[value]}
                                  </option>
                              )
                          )}
                </select>
            )
        } else if (this.props.typeDropDown == 'trainList') {
            const { aiType } = this.props
            return (
                <select
                    onChange={this.onChange}
                    style={style}
                    value={this.props.selected}
                    disabled={this.props.disabled}
                >
                    {this.props.order.map((ele, index) => {
                        if (!ele?.label?.trim()) {
                            return
                        }
                        return (
                            <option
                                className="sensor-txt"
                                key={index}
                                value={this.getOptionValue(ele, index)}
                            >
                                {ele.label}
                            </option>
                        )
                    })}
                </select>
            )
        } else {
            return (
                <select
                    onChange={this.onChange}
                    style={style}
                    value={this.props.selected}
                    disabled={this.props.disabled}
                >
                    {this.props.order
                        ? this.props.order.map((value, index) => (
                              <option
                                  className="sensor-txt"
                                  key={index}
                                  value={value}
                              >
                                  {customOptions[index]}
                                  {/* {this.props.options[value] || value} */}
                              </option>
                          ))
                        : Object.keys(this.props.options).map(
                              (value, index) => (
                                  <option
                                      className="sensor-txt"
                                      key={index}
                                      value={value}
                                  >
                                      {this.props.options[value]}
                                  </option>
                              )
                          )}
                </select>
            )
        }
    }
}
const mapStateToProps = (state) => {
    return {
        aiFaceList: state.assembly?.assemblyPageAi?.aiFaceList,
    }
}

export default connect(mapStateToProps)(Select)
